<template>
  <AlertPopup ref="totalStockListPopEl" size="type-xlarge">
    <template #content>
      <div
        class="text-wrap"
        v-if="props.product.setgdYn == 'Y'"
        style="text-align: left"
      >
        <p style="font-weight: bold">
          [{{ props.product.matnr }}] {{ props.product.zzmaktx }} 세트
          <template v-for="stock in productStocks" :key="stock.werks">
            <template v-if="stock.matnr == 'qtySum'">
              <br /><br />
              재고수량 : {{ stock.labst }} <br /><br />
              하위품목
              <br />
            </template>
          </template>
        </p>
        <template v-for="stock in productStocks" :key="stock.werks">
          <template v-if="!stock.werks && stock.matnr != 'qtySum'">
            <br />
            <p>{{ stock.matnr }}</p>
          </template>
          <template v-if="stock.werks">
            <span>
              {{
                Utils.replace(
                  Utils.codeNm(props.werks, stock.werks),
                  "노루페인트",
                  ""
                )
              }}
              :
              {{ Utils.currency(stock.labst) }}
            </span>
            <br />
          </template>
        </template>
      </div>
      <div class="text-wrap" v-if="props.product.setgdYn == 'N'">
        <p class="text" v-if="productStocks.length > 0">
          <template v-for="stock in productStocks" :key="stock.werks">
            <span>
              {{
                Utils.replace(
                  Utils.codeNm(props.werks, stock.werks),
                  "노루페인트",
                  ""
                )
              }}
              :
              {{ Utils.currency(stock.labst) }}
            </span>
            <br />
          </template>
        </p>
        <p v-else>재고가 없습니다.</p>
      </div>
    </template>
    <template #buttons>
      <div class="c-btn-area">
        <button
          type="button"
          class="c-button type-primary"
          @click="
            () => {
              totalStockListPopEl.closePopup();
              emit('close');
            }
          "
        >
          <span>확인</span>
        </button>
      </div>
    </template>
  </AlertPopup>
</template>
<script setup name="AlertWerks">
import { useAuthStore } from "@/store";
import {
  onMounted,
  defineProps,
  watch,
  reactive,
  inject,
  ref,
  defineEmits,
} from "vue";
import Utils from "@/js/utils";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil.js";
import AlertPopup from "@/components/paintpro/common/alert.vue";
import { boolean } from "yup";
const url = inject("url_prefix");
const totalStockListPopEl = ref();
const authStore = useAuthStore();
const emit = defineEmits(["close"]);
const props = defineProps({
  totalStockListPopEl: {
    type: boolean,
    required: false,
  },
  product: {
    type: Object,
    required: false,
  },
  werks: {
    type: Object,
    required: false,
  },
});

watch(
  () => props.totalStockListPopEl,
  (newValue) => {
    if (newValue) {
      loadProductStocks();
    } else {
      totalStockListPopEl.value.closePopup();
      emit("close");
    }
  }
);

onMounted(() => {});

const productStocks = ref([]);
let user = reactive({});
const loadProductStocks = async () => {
  cmUtil.loading("", { duration: 60000 });

  user = authStore?.user;

  console.log(
    `${url}/product/item-stocks/${user.vwerk}/${Utils.replace(props.product.matnr, "/", "-")}`
  );

  const res = await api.get(
    `${url}/product/item-stocks/${user.vwerk}/${Utils.replace(props.product.matnr, "/", "-")}`
  );

  cmUtil.loadingHide();

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  } else {
    totalStockListPopEl.value.openPopup();
  }

  productStocks.value = res.data;
};
</script>

<style>
.alert .dialog {
  width: auto !important;
  min-width: 280px;
}
</style>
